export default function HeroIllustration() {
  return (
    <svg
      viewBox="0 0 500 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto max-w-lg"
      aria-hidden="true"
    >
      {/* Globe */}
      <circle cx="200" cy="180" r="80" fill="#4A97C9" opacity="0.9" />
      <ellipse cx="200" cy="180" rx="80" ry="80" stroke="#D6E8F2" strokeWidth="1.5" fill="none" />
      <path d="M200 100 C220 130, 230 160, 200 180 C170 200, 160 230, 200 260" stroke="#D6E8F2" strokeWidth="1.5" fill="none" />
      <path d="M200 100 C180 130, 170 160, 200 180 C230 200, 240 230, 200 260" stroke="#D6E8F2" strokeWidth="1.5" fill="none" />
      <ellipse cx="200" cy="140" rx="60" ry="12" stroke="#D6E8F2" strokeWidth="1" fill="none" />
      <ellipse cx="200" cy="220" rx="60" ry="12" stroke="#D6E8F2" strokeWidth="1" fill="none" />
      {/* Landmasses */}
      <path d="M160 150 C170 140, 190 135, 195 145 C200 155, 185 160, 175 155 Z" fill="#5E9732" opacity="0.7" />
      <path d="M210 160 C225 150, 245 155, 240 170 C235 185, 220 180, 215 170 Z" fill="#5E9732" opacity="0.7" />
      <path d="M180 190 C190 185, 210 190, 205 200 C200 210, 185 205, 180 195 Z" fill="#5E9732" opacity="0.6" />

      {/* Laptop/Screen - right */}
      <rect x="310" y="130" width="140" height="95" rx="6" fill="#003a5c" />
      <rect x="316" y="136" width="128" height="78" rx="3" fill="#D6E8F2" />
      {/* Screen content lines */}
      <rect x="326" y="148" width="50" height="4" rx="2" fill="#005288" />
      <rect x="326" y="158" width="108" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="326" y="166" width="95" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="326" y="174" width="100" height="3" rx="1.5" fill="#C0C2C4" />
      {/* Play button on screen */}
      <circle cx="410" cy="185" r="14" fill="#5E9732" />
      <polygon points="406,178 406,192 418,185" fill="white" />
      {/* Laptop base */}
      <rect x="295" y="225" width="170" height="10" rx="3" fill="#003a5c" />

      {/* Stacked books - bottom left */}
      <rect x="80" y="270" width="120" height="18" rx="3" fill="#E8642C" />
      <rect x="75" y="252" width="130" height="18" rx="3" fill="#005288" />
      <rect x="82" y="234" width="115" height="18" rx="3" fill="#5E9732" />
      <rect x="78" y="216" width="125" height="18" rx="3" fill="#4A97C9" />
      {/* Top book slightly angled */}
      <rect x="85" y="198" width="110" height="18" rx="3" fill="#003a5c" transform="rotate(-3 140 207)" />

      {/* Document/certificate - right side */}
      <rect x="340" y="260" width="90" height="110" rx="4" fill="white" stroke="#DFE1E2" strokeWidth="1.5" />
      <rect x="355" y="275" width="60" height="5" rx="2.5" fill="#005288" />
      <rect x="355" y="286" width="50" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="355" y="294" width="55" height="3" rx="1.5" fill="#C0C2C4" />
      <rect x="355" y="302" width="45" height="3" rx="1.5" fill="#C0C2C4" />
      {/* Checkmark seal */}
      <circle cx="385" cy="340" r="16" fill="#5E9732" opacity="0.15" />
      <circle cx="385" cy="340" r="12" fill="#5E9732" />
      <path d="M379 340 L383 344 L391 336" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />

      {/* Small floating document */}
      <rect x="250" y="270" width="60" height="75" rx="3" fill="white" stroke="#DFE1E2" strokeWidth="1" />
      <rect x="260" y="282" width="40" height="3" rx="1.5" fill="#005288" />
      <rect x="260" y="290" width="35" height="2" rx="1" fill="#C0C2C4" />
      <rect x="260" y="296" width="38" height="2" rx="1" fill="#C0C2C4" />
      <rect x="260" y="302" width="30" height="2" rx="1" fill="#C0C2C4" />

      {/* Graduation cap on top of globe */}
      <path d="M170 105 L200 88 L230 105 L200 115 Z" fill="#003a5c" />
      <line x1="200" y1="115" x2="200" y2="135" stroke="#003a5c" strokeWidth="2" />
      <path d="M215 110 L215 125 C215 130, 200 135, 200 135 C200 135, 185 130, 185 125 L185 110" fill="#005288" opacity="0.6" />
    </svg>
  )
}
